<template>
	<div>
		<Breadcrumbs main="Support Management" title="Supports" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_support' }" class="btn btn-primary float-end">Create Support</router-link>
									</div>
								</div>
							</div>

								<div class="col-md-12 project-list filter-sort mb-3">
									<div class="row">
										<div class="col-md-4 d-flex align-items-end gap-3 mt-2">
											<div>
												<label class="control-label d-block">Total Supports:</label>
												<span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
											</div>
											<button type="button" class="btn btn-success" @click="downloadSupportsExcel()" :disabled="!start_date || !end_date || excel_loading">
												{{ excel_loading ? 'Exporting...' : 'Export Excel' }}
											</button>
										</div>
										<div class="col-md-2 mt-2">
											<label class="control-label">Status</label>
											<select class="form-select" v-model="status" @change="fetchSupports()">
												<option value="">All Status</option>
												<option value="1">Pending</option>
												<option value="2">Ongoing</option>
												<option value="4">To Speedtech</option>
												<option value="5">To Technician</option>
												<option value="6">To Service</option>
											</select>
										</div>
										<div class="col-md-2 mt-2">
											<label class="control-label">Support Type</label>
											<select class="form-select" v-model="support_type" @change="fetchSupports()">
												<option value="">All Types</option>
												<option value="1">No Data</option>
												<option value="2">Tracking Issue</option>
												<option value="3">Software Issue</option>
												<option value="4">Alert Fail</option>
												<option value="5">CDCA Alert</option>
												<option value="6">3rd Party App Point</option>
												<option value="7">Other</option>
											</select>
										</div>
										<div class="col-md-2 mt-2">
											<label class="control-label">Start Date:</label>
											<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchSupports()">
											</div>
											<div class="col-md-2 mt-2">
												<label class="control-label">End Date:</label>
												<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchSupports()">
												</div>
											</div>
										</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-4 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchSupports()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="50">50</option>
												<option value="100">100</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control" placeholder="Search IMEI / Name / Mobile" v-model="keyword" @input="fetchSupports()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="supports-table">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>IMEI</th>
											<th>Type</th>
											<th>Requested By</th>
											<th>Details</th>
											<th>Date</th>
											<th>Added By</th>
											<th>Status</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(supports.length)">
										<tr v-for="(item, index) in supports" :key="item.id" align="center">
											<td>{{ from + index }}</td>
											<td>
												<b>IMEI:</b> {{ item.imei || item.device_imei || '-' }}<br>
												<span v-if="item.iccid"><b>ICCID:</b> {{ item.iccid }}</span>
											</td>
											<td>{{ supportTypeLabel(item.support_type) }}</td>
											<td>
												<span v-if="item.requested_by == 1">Customer: {{ item.customer_name_user || item.customer_name || '-' }}</span>
												<span v-else-if="item.requested_by == 2">Dealer: {{ item.dealer_name || '-' }}</span>
												<span v-else>-</span>
												<div v-if="item.mobile"><small>{{ item.mobile }}</small></div>
											</td>
											<td>{{ item.details || '-' }}</td>
											<td>{{ item.created_date || '-' }}</td>
											<td>{{ item.added_user_name || '-' }}</td>
											<td>
												<span class="badge rounded-pill bg-warning" v-if="item.status == 1">Pending</span>
												<span class="badge rounded-pill bg-info" v-else-if="item.status == 2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-else-if="item.status == 3">Completed</span>
												<span class="badge rounded-pill bg-primary" v-else-if="item.status == 4">To Speedtech</span>
												<span class="badge rounded-pill bg-secondary" v-else-if="item.status == 5">To Technician</span>
												<span class="badge rounded-pill bg-dark" v-else-if="item.status == 6">To Service</span>
												<span class="badge rounded-pill bg-light text-dark" v-else>{{ item.status }}</span>
												<div v-if="item.technician_name" class="mt-1"><small>{{ item.technician_name }}</small></div>
											</td>
											<td>
												<router-link :to="{ name: 'support_details', params: { id: item.id } }" class="btn btn-sm btn-primary">
													View
												</router-link>
												<button v-if="item.status == 1" class="btn btn-sm btn-danger ms-1" @click="deleteSupport(item.id)">Delete</button>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="9" align="center">No supports found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(supports.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="page.label"
									>
										<a
											class="page-link"
											href="#"
											@click.prevent="fetchSupports(buildQueryString(page.url))"
											tabindex="-1"
										>
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Supports',
	data() {
		return {
			token: '',
			user: null,
			supports: [],
			pagination: [],
			listing_length: 10,
			keyword: '',
			status: '',
			support_type: '',
			start_date: '',
			end_date: new Date().toISOString().slice(0, 10),
			max: new Date().toISOString().slice(0, 10),
			excel_loading: false,
			from: 0,
			to: 0,
			total: 0,
		};
	},
	mounted() {
		this.fetchSupports();
	},
	methods: {
		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				const airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff'));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal('', 'Failed to fetch token, please login again', 'error');
					this.$router.push({ name: 'login' });
				}
			} else {
				this.$swal('', 'Session expired, please login again', 'error');
				this.$router.push({ name: 'login' });
			}
		},
		supportTypeLabel(type) {
			const map = {
				1: 'No Data',
				2: 'Tracking Issue',
				3: 'Software Issue',
				4: 'Alert Fail',
				5: 'CDCA Alert',
				6: '3rd Party App Point',
				7: 'Other',
			};
			return map[type] || 'N/A';
		},
		buildQueryString(baseUrl = null) {
			const params = new URLSearchParams();
			params.append('limit', this.listing_length);
			if (this.keyword && this.keyword.trim()) {
				params.append('keyword', this.keyword.trim());
			}
			if (this.status) {
				params.append('status', this.status);
			}
			if (this.support_type) {
				params.append('support_type', this.support_type);
			}
			if (this.start_date) {
				params.append('from_date', this.start_date);
			}
			if (this.end_date) {
				params.append('to_date', this.end_date);
			}
			if (baseUrl) {
				const separator = baseUrl.includes('?') ? '&' : '?';
				return baseUrl + separator + params.toString();
			}
			return '/staffs/supports?' + params.toString();
		},
		downloadSupportsExcel() {
			if (!this.start_date || !this.end_date) return;

			this.getToken();
			const params = new URLSearchParams({
				keyword: String(this.keyword || "").trim(),
					status: this.status || "",
				support_type: this.support_type || "",
				from_date: this.start_date,
				to_date: this.end_date,
			});
			this.excel_loading = true;
			this.$axios
				.get("/staffs/supportsExcel?" + params.toString(), { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
				.then((response) => {
					const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = "supports_" + this.start_date + "_" + this.end_date + ".xlsx";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(link.href);
				})
				.catch((err) => console.log(err))
				.finally(() => {
					this.excel_loading = false;
				});
		},

		fetchSupports(page_url = null) {
			this.getToken();
			page_url = page_url || this.buildQueryString();
			this.$axios
				.get(page_url, { headers: { Authorization: 'Bearer ' + this.token } })
				.then((res) => {
					const responseData = res.data.data || {};
					const page = responseData.supports || {};
					this.supports = page.data || [];
					this.pagination = page.links || [];
					this.from = page.from || 0;
					this.to = page.to || 0;
					this.total = page.total || 0;
				})
				.catch((err) => {
					console.log(err);
					this.$swal('Error', this.$getApiErrorMessage?.(err, 'Failed to load supports') || 'Failed to load supports', 'error');
				});
		},
		deleteSupport(id) {
			this.$swal({
				icon: 'warning',
				title: 'Confirm',
				text: 'Are you sure you want to delete this pending support?',
				showCancelButton: true,
				confirmButtonText: 'Yes',
				confirmButtonColor: '#e64942',
				cancelButtonText: 'No',
				position: 'center',
				showConfirmButton: true,
				timer: '',
				toast: false,
				cancelButtonColor: '#efefef',
			}).then((result) => {
				if (result.value) {
					this.getToken();
					this.$axios
						.post('/staffs/deleteSupport', { support_id: id }, { headers: { Authorization: 'Bearer ' + this.token } })
						.then((res) => {
							this.$swal('', res.data.message || 'Support deleted successfully', 'success');
							this.fetchSupports();
						})
						.catch((err) => {
							this.$swal('Error', this.$getApiErrorMessage?.(err, 'Failed to delete support') || 'Failed to delete support', 'error');
						});
				}
			});
		},
	},
};
</script>

<style>
@import '@/assets/css/custom.css';
</style>
